export const getTranslations = t => {
  return {
    viewDetails: t("kf.pdp.bundles.viewDetails"),
    includedItemsLabel: t("kf.pdp.bundles.includedItems"),
    colorOrFinish: t("kf.pdp.label.colorOrFinish"),
    qty: t("kf.checkout.label.qtyLabel"),
    subTotal: t("kf.pdp.label.subTotal"),
    subTotalItems: number => t("kf.pdp.bundles.subTotalItems", { number }),
    saveOnBundle: number => t("kf.pdp.bundles.saveOnBundle", { number }),
    includedItemsQty: number =>
      t("kf.pdp.bundles.includedItemsQty", { number }),
    featuresLabel: t("kf.pdp.label.features"),
    specsInstallationLabel: t("kf.pdp.bundles.specsInstallation"),
    downloadAllSpecSheetsLabel: t("kf.pdp.bundles.downloadAllSpecSheets"),
    downloadAllInstallGuidesLabel: t("kf.pdp.bundles.downloadAllInstallGuides"),
    cannotShipLabel: t("kf.cart.label.cannotShip"),
    includedPdpItemsLabel: t("kf.pdp.bundles.includedPdpItemsLabel"),
    outOfStockLabel: t("kf.cart.label.outOfStock"),
  }
}
